module.exports = __webpack_public_path__ + "static/awaken-the-giant-within-b801c6d75826ef2ecd3c82fbb0c71776.jpg";